import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import loadingQuedaAnimation from '@/assets/lottie/loading-queda.json'

export function LearnerLoading() {
  const { t } = useTranslation('learner')

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="pointer-events-none fixed inset-0 z-10 flex items-center justify-center p-4"
    >
      <Lottie
        animationData={loadingQuedaAnimation}
        autoplay
        loop
        aria-hidden="true"
        className="w-[160px] max-w-full sm:w-[192px]"
      />
      <span className="sr-only">{t('learn.loading')}</span>
    </div>
  )
}
